const globalKey = '__ENV__';

export default globalKey;
